import statusWithdrawalService from '@/store/services/statusWithdrawalService'

const state = {
  field: {
    keyword: null,
    paginate: 10,
  },
  keyword_field: null,
  paginate_field: null,
  metaStatusWithdrawal: null,
  statusWithdrawal: null,
}

const getters = {
  statuses_withdrawal: state => (state.metaStatusWithdrawal ? state.metaStatusWithdrawal.data : []),
  current_page: state => (state.metaStatusWithdrawal ? state.metaStatusWithdrawal.current_page : 0),
  last_page: state => (state.metaStatusWithdrawal ? state.metaStatusWithdrawal.last_page : 0),
  per_page: state => (state.metaStatusWithdrawal ? state.metaStatusWithdrawal.per_page : 0),
  total: state => (state.metaStatusWithdrawal ? state.metaStatusWithdrawal.total : 0),
}

const actions = {
  getStatusesWithdrawalList({ commit, state }, { page, field }) {
    if (state.metaStatusWithdrawal && state.metaStatusWithdrawal.current_page === page
      && state.keyword_field === field.keyword && state.paginate_field === field.paginate) return state.metaStatusWithdrawal

    return statusWithdrawalService.getStatusesWithdrawalList(page, field).then(({ data }) => {
      commit('SET_META_STATUS_WITHDRAWAL', data.result)
      commit('SET_KEYWORD_FIELD', field.keyword)
      commit('SET_PAGINATE_FIELD', field.paginate)
      commit('SET_FIELD', field)

      return data
    })
  },

  refreshStatusesWithdrawalList({ commit, state }, { page, field }) {
    return statusWithdrawalService.getStatusesWithdrawalList(page, field).then(({ data }) => {
      commit('SET_META_STATUS_WITHDRAWAL', data.result)
      commit('SET_KEYWORD_FIELD', field.keyword)
      commit('SET_PAGINATE_FIELD', field.paginate)
      commit('SET_FIELD', field)

      return data
    })
  },

  getStatusWithdrawalById({ commit }, id) {
    return statusWithdrawalService.getStatusWithdrawal(id).then(({ data }) => {
      commit('SET_STATUS_WITHDRAWAL', data.result)

      return data
    })
  },

  updateStatusWithdrawal({ commit }, field) {
    return statusWithdrawalService.updateStatusWithdrawal(field).then(({ data }) => {
      commit('UPDATE_STATUS_WITHDRAWAL', { statusWithdrawal: data.result, item: field })

      return data
    })
  },

  addStatusWithdrawal({ commit }, field) {
    return statusWithdrawalService.addStatusWithdrawal(field).then(({ data }) => {
      commit('ADD_STATUS_WITHDRAWAL', data.result)

      return data
    })
  },

  deleteStatusWithdrawal({ commit }, field) {
    return statusWithdrawalService.deleteStatusWithdrawal(field).then(({ data }) => {
      commit('UPDATE_STATUS_WITHDRAWAL', { statusWithdrawal: data.result, item: field })

      return data
    })
  },

  restoreStatusWithdrawal({ commit }, field) {
    return statusWithdrawalService.restoreStatusWithdrawal(field).then(({ data }) => {
      commit('UPDATE_STATUS_WITHDRAWAL', { statusWithdrawal: data.result, item: field })

      return data
    })
  },

}

const mutations = {
  UPDATE_STATUS_WITHDRAWAL(state, { statusWithdrawal, item }) {
    if (state.metaStatusWithdrawal) { state.metaStatusWithdrawal.data.splice(state.metaStatusWithdrawal.data.findIndex(t => t.id === item.id), 1, statusWithdrawal) }
  },

  ADD_STATUS_WITHDRAWAL(state, statusWithdrawal) {
    state.metaStatusWithdrawal.data.unshift(statusWithdrawal)
  },

  SET_STATUS_WITHDRAWAL(state, item) {
    state.statusWithdrawal = item
  },
  
  SET_PAGINATE_FIELD(state, paginante) {
    state.paginate_field = paginante
  },

  SET_KEYWORD_FIELD(state, keyword) {
    state.keyword_field = keyword
  },

  SET_META_STATUS_WITHDRAWAL(state, metaStatusWithdrawal) {
    state.metaStatusWithdrawal = metaStatusWithdrawal
  },

  SET_FIELD(state, field) {
    state.field = field
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
